import { SVGProps, Ref, forwardRef } from 'react';

export const PlayCircleFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="m8 .5.517.01c5.055.217 6.866 3.626 6.977 7.138L15.5 8c0 3.75-1.875 7.5-7.5 7.5S.5 11.75.5 8l.006-.352C.62 4.02 2.55.5 8 .5m-.3 4.8c-1.069-.541-1.604-.812-1.985-.504S5.333 5.81 5.333 7.22v1.558c0 1.41 0 2.116.382 2.424.38.309.916.038 1.988-.505l1.541-.779C10.86 9.102 11.667 8.693 11.667 8s-.808-1.102-2.423-1.919l-1.54-.78z"
                fill="currentColor"
            />
        </g>
    </svg>
));
PlayCircleFilledSize16Glyph.displayName = 'PlayCircleFilledSize16Glyph';
